import React from "react";
import MuiTextField from "@mui/material/TextField";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckOutlined from "@mui/icons-material/CheckOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import IconButton from "@mui/material/IconButton";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelDatepicker from "../model/Datepicker";
import ControllerDatepicker from "../controller/Datepicker";
import ControllerLocalization from "../controller/Localization";

let isRendered = false;

const viewDatepicker: React.FC<ModelDatepicker.Iprops> = (props) => {
    // Variable
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onConfirm, language, fieldMode, ...textFieldProps } = props;

    const controllerDatepicker = new ControllerDatepicker(props, isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerDatepicker.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_datepicker" id={`view_datepicker_${props.id || ""}`}>
                <MuiTextField {...textFieldProps} />
                {(() => {
                    const html: JSX.Element[] = [];

                    if (!props.disabled) {
                        html.push(
                            <IconButton onClick={() => controllerDatepicker.clickOpen()} data-at_id="datepicker_open" className="open">
                                <CalendarTodayIcon />
                            </IconButton>
                        );
                    }

                    return html;
                })()}
                <div className="tooltip">
                    {(() => {
                        const html: JSX.Element[] = [];

                        const year = (
                            <div className="year">
                                <ArrowDropUpIcon
                                    className="icon"
                                    data-at_id="datepicker_year_up"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("year", "up");
                                    }}
                                />
                                <p>{controllerDatepicker.getYear}</p>
                                <ArrowDropDownIcon
                                    className="icon"
                                    data-at_id="datepicker_year_down"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("year", "down");
                                    }}
                                />
                            </div>
                        );

                        const month = (
                            <div className="month">
                                <ArrowDropUpIcon
                                    className="icon"
                                    data-at_id="datepicker_month_up"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("month", "up");
                                    }}
                                />
                                <p>{controllerDatepicker.getMonth}</p>
                                <ArrowDropDownIcon
                                    className="icon"
                                    data-at_id="datepicker_month_down"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("month", "down");
                                    }}
                                />
                            </div>
                        );

                        const day = (
                            <div className="day">
                                <ArrowDropUpIcon
                                    className="icon"
                                    data-at_id="datepicker_day_up"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("day", "up");
                                    }}
                                />
                                <p>{controllerDatepicker.getDay}</p>
                                <ArrowDropDownIcon
                                    className="icon"
                                    data-at_id="datepicker_day_down"
                                    onClick={() => {
                                        controllerDatepicker.clickItem("day", "down");
                                    }}
                                />
                            </div>
                        );

                        if (controllerDatepicker.getStorageLocalization && controllerDatepicker.getStoragePreference) {
                            let locale = controllerDatepicker.getLanguage;

                            const localeSplit = locale.split("_");

                            if (localeSplit.length === 1) {
                                locale = controllerDatepicker.getLocale;
                            } else {
                                locale = `${localeSplit[0]}-${localeSplit[1].toUpperCase()}`;
                            }

                            let currentDateFormat = "";

                            for (const config of Object.values(HelperSrc.localeConfiguration)) {
                                if (locale === config.locale) {
                                    currentDateFormat = config.dateFormat;
                                }
                            }

                            if (currentDateFormat === "a") {
                                html.push(year);

                                if (controllerDatepicker.getMode === "yearMonth" || controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(month);
                                }

                                if (controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(day);
                                }
                            } else if (currentDateFormat === "b") {
                                if (controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(day);
                                }

                                if (controllerDatepicker.getMode === "yearMonth" || controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(month);
                                }

                                html.push(year);
                            } else if (currentDateFormat === "c") {
                                if (controllerDatepicker.getMode === "yearMonth" || controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(month);
                                }

                                if (controllerDatepicker.getMode === "yearMonthDay") {
                                    html.push(day);
                                }

                                html.push(year);
                            }
                        }

                        html.push(
                            <IconButton onClick={() => controllerDatepicker.clickConfirm()} data-at_id="datepicker_confirm" className="confirm">
                                <CheckOutlined />
                            </IconButton>
                        );

                        return html;
                    })()}
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export default viewDatepicker;
